import { render, staticRenderFns } from "./TechAddJob.vue?vue&type=template&id=07990882&scoped=true"
import script from "./TechAddJob.vue?vue&type=script&lang=js"
export * from "./TechAddJob.vue?vue&type=script&lang=js"
import style0 from "./TechAddJob.vue?vue&type=style&index=0&id=07990882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07990882",
  null
  
)

export default component.exports